import React from 'react';

import { Dentist } from '@/data/Dentists';
import { formatDentistName } from '@/utils/helpers/formatDentistName';

import './ScheduleFlowSummary.css';

interface ScheduleFlowSummaryProps {
  branchName?: string | null;
  dentist?: Dentist | null;
  showEstimate?: boolean;
}

const ScheduleFlowSummary: React.FC<ScheduleFlowSummaryProps> = ({
  branchName,
  dentist,
  showEstimate
}) => {
  const labels = {
    branch: 'Branch',
    dentist: 'Dentist',
    estimatedTime: 'Estimated Completion Time'
  };

  return (
    <div className="schedule-flow-summary">
      {branchName && (
        <div className="schedule-flow-detail">
          <p className="schedule-flow-detail__label">{labels.branch}</p>
          <p className="schedule-flow-detail__value">{branchName}</p>
        </div>
      )}
      {dentist && (
        <div className="schedule-flow-detail">
          <p className="schedule-flow-detail__label">{labels.dentist}</p>
          <p className="schedule-flow-detail__value">
            {formatDentistName({
              dentist,
              returnDentistFullName: true
            })}
          </p>
        </div>
      )}
      {showEstimate && (
        <div className="schedule-flow-detail">
          <p className="schedule-flow-detail__label">{labels.estimatedTime}</p>
          <p className="schedule-flow-detail__value">~3 minutes</p>
        </div>
      )}
    </div>
  );
};

export default ScheduleFlowSummary;
